{
  "settings": "Beállítások",
  "yourDigitalAssistant": "Az Ön Digitális Asszisztense",
  "getStarted": "Beszélgetés kezdése",
  "login": "Bejelentkezés",
  "loggingIn": "Bejelentkezés folyamatban...",
  "darkMode": "Éjszakai mód",
  "clearHistory": "Előzmények törlése",
  "historyCleared": "Beszélgetés előzmények törölve",
  "changeLanguage": "Beszélgetés nyelve",
  "termsAndConditions": "Általános Szerződési Feltételek",
  "messagePlaceholder": "Írja ide kérdését ...",
  "messagePlaceholderDisabled": "Gépelés letiltva ...",
  "feedbackTitle": "Hogyan értékelné a beszélgetést?",
  "feedbackPlaceholder": "Szöveges visszajelzés (opcionális)",
  "feedbackSend": "Küldés",
  "feedbackClose": "Szorosan",
  "sessionExpired": "Beszélgetése inaktivitás miatt lezárult.",
  "startNewSession": "Új beszélgetés",
  "apiError": "Hoppá! Valami hibás. Dolgozunk azon, hogy ezt mihamarabb megjavítsuk.",
  "apiErrorOffline": "Nincs internetkapcsolat.",
  "tryAgain": "Próbálja újra",
  "startOver": "Elölről kezdeni",
  "chatEnded": "A csevegés befejeződött.",
  "chatEndedThankYou": "Köszönjük, hogy beszélgetett velünk!",
  "closeChat": "Bezárás",
  "startNewChat": "Csevegjen újra",
  "humanTakeoverStarted": "Most áttér az ügyfélszolgálathoz ...",
  "humanTakeoverQueued": "Várakozás az ügynökhöz való kapcsolódásra",
  "humanTakeoverAnAgent": "Egy ügynök",
  "humanTakeoverAgentEntered": "belépett a beszélgetésbe",
  "humanTakeoverAgentLogout": "kilépett a beszélgetésből",
  "humanTakeoverTransfer": "Áthelyezik egy új ügynökbe",
  "humanTakeoverEnded": "Most már a digitális asszisztenssel beszélget",
  "version": "Verzió",
  "formIntroText": "Kérem töltse ki az alábbi mezőket, hogy elinduljon a beszélgetés.",
  "formFirstName": "Keresztnév",
  "formLastName": "Vezetéknév",
  "formName": "Név",
  "formEmail": "E-mail",
  "formWrongEmail": "Valós e-mail címet adjon meg.",
  "formPhone": "Telefonszám",
  "formShipmentId": "Szállítmány azonosító",
  "formQuestion": "Kérdése hozzánk",
  "formAccountNumber": "Számlaszám (üzleti ügyfelek számára)",
  "formAddress": "Cím",
  "formPostcode": "Irányítószám",
  "formCity": "Város",
  "formCountry": "Ország",
  "formSubmitButton": "Beszélgetés indítása",
  "formEmptyFieldError": "Kötelező kitölteni.",
  "formPhoneNumberValidationError": "Valós telefonszámot adjon meg.",
  "formInputIsBiggerThan50": "Túllépte az 50 karakteres maximális hosszúságot.",
  "formInputIsBiggerThan100": "Túllépte a 100 karakteres maximális hosszúságot.",
  "formInputIsBiggerThan2000": "Túllépte a 2000 karakteres maximális hosszúságot.",
  "widgetEventOnline": "DA üzenet: A felhasználó visszatér online.",
  "widgetEventHidden": "DA üzenet: A widget rejtett.",
  "widgetEventVisible": "DA üzenet: A widget látható.",
  "widgetEventVisibleMinimized": "DA üzenet: A widget látható, de minimalizálva.",
  "widgetEventMinimized": "DA üzenet: A widget minimalizálva vannak.",
  "widgetEventMaximized": "DA üzenet: A widget maximalizálva van.",
  "widgetEventSessionExpired": "DA üzenet: A widget munkamenet lejárt.",
  "widgetEventHangupHuman": "DA üzenet: A felhasználó befejezi az emberi átvételi munkamenetet.",
  "widgetEventUserTyping": "DA üzenet: a felhasználó gépel.",
  "fileTooLarge": "A Csatolt Fájl Mérete Túl Nagy.",
  "tooManyDiles": "Túl Sok Fájlt Próbált Csatolni.",
  "fileInvalidType": "A Csatolt Fájl Típusa Nincs Támogatva.",
  "attachmentsDropHere": "Bodja ide a feltöltéshez vagy",
  "attachmentsBrowse": "Fájl keresése",
  "attachmentsExtenstionQuantity": "pdf vagy kép (maximum 10 fájl)",
  "attachmentsSize": "maximum 30 MB",
  "attachmentsFailedUploading": "Feltöltés sikertelen",
  "attachmentsUploading": "Feltöltés...",
  "minimizeExpandText": "Élő chatelj velünk most!",
  "popupWidgetNotificationMessage": "Új üzenetet kapott!",
  "tabWidgetNotificationMessage": "Új üzenet!",
  "datepickerSendButton": "Küld"
}
